import { Component, Input, OnInit } from '@angular/core';

interface Testimony {
  name: string;
  position: string;
  image: string;
  text: string;
  rating: number;
}

@Component({
  selector: 'app-sblock-testimonials-2col',
  templateUrl: './testimonials-2col.component.html',
  styleUrls: ['./testimonials-2col.component.scss']
})
export class SblockTestimonials2colComponent implements OnInit {
  /** Section heading and eyebrow — rich-text (innerHTML) coming from the API */
  @Input() title = '';
  @Input() subtitle = '';
  titlesColor = '#1f1f5e';
  secondaryColor = '#932F29';

  pageIndex = 0;
  primaryColor = '#29166F';

  /** Fallback avatar when a testimony has no photo */
  private readonly fallbackAvatar = 'assets/images/empty_user.png';

  /** Shows skeleton placeholders while the parent is fetching data */
  @Input() loading = false;

  /** Testimonials come from the parent; no placeholder/demo fallbacks */
  @Input() testimonials: Testimony[] = [];

  /** Skeleton cards rendered while loading */
  skeletonCards = [0, 1];

  ngOnInit(): void {}

  get itemsPerPage(): number {
    return 2;
  }

  get totalPages(): number {
    return Math.ceil(this.testimonials.length / this.itemsPerPage);
  }

  get pages(): any[][] {
    const result: any[][] = [];
    const per = this.itemsPerPage;
    for (let i = 0; i < this.testimonials.length; i += per) {
      result.push(this.testimonials.slice(i, i + per));
    }
    return result;
  }

  nextSlide(): void {
    this.pageIndex = (this.pageIndex + 1) % this.totalPages;
  }

  prevSlide(): void {
    this.pageIndex = (this.pageIndex - 1 + this.totalPages) % this.totalPages;
  }

  goToPage(index: number): void {
    this.pageIndex = index;
  }

  getImage(item: any): string {
    return item.image || this.fallbackAvatar;
  }

  hasTitleLink(): boolean {
    return false;
  }

  gotToLink(): void {}

  getRating(item: any): number {
    const r = Number(item.rating);
    if (!r || isNaN(r)) {
      return 5;
    }
    return Math.max(0, Math.min(5, Math.round(r)));
  }

  stars(item: any): number[] {
    return Array(this.getRating(item)).fill(0);
  }

  emptyStars(item: any): number[] {
    return Array(5 - this.getRating(item)).fill(0);
  }
}
